module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-709f7981","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/subroute.vue
// module id = 377
// module chunks = 9